(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["beauty-banner"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('swiper-slider')) {
    customElements.define(
      'swiper-slider',
      class extends HTMLElement {
        connectedCallback() {
          if (this.swiperInstance || typeof Swiper === 'undefined') return;
          const container = this.querySelector('.swiper');
          if (!container) return;

          let config = {};
          try {
            config = JSON.parse(this.getAttribute('data-config') || '{}');
          } catch (error) {
            config = {};
          }

          const paginationEl = this.querySelector('.swiper-pagination');
          const nextEl = this.querySelector('.swiper-button-next');
          const prevEl = this.querySelector('.swiper-button-prev');

          if (paginationEl) {
            config.pagination = Object.assign(
              { el: paginationEl, clickable: true },
              config.pagination || {}
            );
          }

          if (nextEl && prevEl) {
            config.navigation = Object.assign(
              { nextEl: nextEl, prevEl: prevEl },
              config.navigation || {}
            );
          }

          this.swiperInstance = new Swiper(container, config);
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["beauty-image-text-grid"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var mq = window.matchMedia('(max-width: 850px)');
    var selector = '.image-text-grid-wrapper[data-layout="accordion"] .image-text-grid-mb-swiper .swiper';

    function spacePx(el, value) {
      var probe = document.createElement('div');
      probe.style.cssText =
        'position:absolute;visibility:hidden;pointer-events:none;width:calc(' + value + ' * var(--px))';
      el.appendChild(probe);
      var value = probe.getBoundingClientRect().width;
      el.removeChild(probe);
      return value;
    }

    function bindAccordionLinks() {
      document.querySelectorAll('.image-text-grid-wrapper[data-layout="accordion"] .image-text-grid-inner--pc').forEach(function (inner) {
        if (inner.dataset.accordionLinksReady === 'true') return;
        inner.dataset.accordionLinksReady = 'true';

        inner.querySelectorAll('a.image-text-grid-item').forEach(function (card) {
          card.addEventListener('click', function (event) {
            if (mq.matches) return;

            var cards = Array.from(inner.querySelectorAll('.image-text-grid-item'));
            var gap = parseFloat(window.getComputedStyle(inner).columnGap) || 0;
            var availableWidth = inner.clientWidth - gap * Math.max(cards.length - 1, 0);
            var expandedWidth = availableWidth * 705 / (705 + 145 * Math.max(cards.length - 1, 0));

            if (card.getBoundingClientRect().width < expandedWidth - 4) {
              event.preventDefault();
              card.focus({ preventScroll: true });
            }
          });
        });
      });
    }

    function sync() {
      bindAccordionLinks();
      document.querySelectorAll(selector).forEach(function (el) {
        var root = el.closest('.image-text-grid-mb-swiper') || el;
        if (mq.matches) {
          if (!el.swiper && typeof Swiper !== 'undefined') {
            var nextEl = root.querySelector('.swiper-button-next');
            var prevEl = root.querySelector('.swiper-button-prev');
            el.swiper = new Swiper(el, {
              slidesPerView: 'auto',
              spaceBetween: spacePx(el, 9),
              slidesOffsetAfter: spacePx(el, 20),
              watchOverflow: true,
              navigation: nextEl && prevEl ? { nextEl: nextEl, prevEl: prevEl } : undefined,
            });
          } else if (el.swiper) {
            el.swiper.params.spaceBetween = spacePx(el, 9);
            el.swiper.params.slidesOffsetAfter = spacePx(el, 20);
            el.swiper.update();
          }
        } else if (el.swiper) {
          el.swiper.destroy(true, true);
          el.swiper = undefined;
        }
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', sync);
    } else {
      sync();
    }
    if (mq.addEventListener) mq.addEventListener('change', sync);
    else mq.addListener(sync);
    document.addEventListener('shopify:section:load', sync);
    window.addEventListener('load', sync);
    window.addEventListener('resize', sync);
  })();

  } catch(e) { console.error(e); }
})();
})();
